import { createSlice, PayloadAction, current } from '@reduxjs/toolkit';

import { INoteStateType, NOTETYPES } from '@shared/models';
import * as Response from '@shared/models/journal/journal.response.type';

import { fetchJournalNotes } from '../queries';

const state: INoteStateType = {
    fetching: false,
    notes: [],
    noteTags: [],
    activeNote: null,
};

const journalNotesSlice = createSlice({
    name: 'journal-notes',
    initialState: state,
    reducers: {
        setJournalNotes: (state, { payload }: PayloadAction<Response.INoteListResponseType>) => {
            state.notes = payload.notes;
            state.noteTags = payload.noteTags;
        },
        setActiveNote: (state, { payload }: PayloadAction<Response.INoteResponseType>) => {
            state.activeNote = payload;
        },
        updateNotes: (state, { payload }: PayloadAction<Response.INoteResponseType>) => {
            state.notes = [payload, ...state.notes];
            state.activeNote = payload;
        },
        setUpdateSingleNote: (state, { payload }: PayloadAction<Response.INoteResponseType>) => {
            if (String(payload?.type).toLowerCase() === 'modul') {
                state.activeNote = {
                    ...state.activeNote,
                    modules: state.activeNote?.modules?.map((el) =>
                        el?.activityId === payload?.activityId
                            ? {
                                  ...el,
                                  body: payload?.body,
                              }
                            : el
                    ),
                };
            } else {
                state.activeNote = { ...state.activeNote, body: payload?.body, jurnalNote: payload?.jurnalNote };
            }
            state.notes = state.notes.map((note) => {
                if (String(payload?.type).toLowerCase() === 'modul' && payload.id === note.id) {
                    return {
                        ...note,
                        modules: note?.modules?.map((el) =>
                            el?.activityId === payload?.activityId
                                ? {
                                      ...el,
                                      body: payload?.body,
                                  }
                                : el
                        ),
                    };
                } else if (payload.id === note.id) {
                    return { ...note, body: payload?.body, jurnalNote: payload?.jurnalNote };
                }

                return note;
            });
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchJournalNotes.pending, (state) => {
            state.fetching = true;
        });
        builder.addCase(fetchJournalNotes.rejected, (state) => {
            state.fetching = false;
        });
        builder.addCase(fetchJournalNotes.fulfilled, (state) => {
            state.fetching = false;
        });
    },
});

export const { setJournalNotes, setActiveNote, updateNotes, setUpdateSingleNote } = journalNotesSlice.actions;
export default journalNotesSlice.reducer;
